<template>
  <v-dialog v-model="mostradoModal" max-width="1200" scrollable>
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">Historial de Estados Académicos</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Fecha Cambio</th>
                    <th>Nro. Estado Anterior</th>
                    <th>Estado Anterior</th>
                    <th>Nro. Estado Nuevo</th>
                    <th>Estado Nuevo</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(item, indice) in historialesEstadosAcademicos" :key="indice">
                    <td>{{ indice + 1 }}</td>
                    <td>{{ item.fechaCambio }}</td>
                    <td>{{ item.estadoAcademicoAnterior?.nro || '-' }}</td>
                    <td>{{ item.estadoAcademicoAnterior?.nombre || '-' }}</td>
                    <td>{{ item.estadoAcademicoNuevo.nro }}</td>
                    <td>{{ item.estadoAcademicoNuevo.nombre }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click="mostradoModal = false"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalHistorialesEstadosAcademicos',
  props: {
    historialesEstadosAcademicos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      mostradoModal: false,
    };
  },
  methods: {
    abrir() {
      this.mostradoModal = true;
    },
  },
};
</script>

<style>
</style>